module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0011.3bb63301.jpg";